module.exports = __webpack_public_path__ + "static/v1.d-c840c007055dc1388132a7d57ca7b563.jpg";